export default "__VITE_ASSET__CQF7RkzI__"